import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListIcon from '@mui/icons-material/List';
import Tooltip from '@mui/material/Tooltip';

const PatientSessionsButton = props => {
  const {iconOnly} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const url = `/providers/sessions?patient_id=${patientId}`;
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !patientId,
    variant: iconOnly ? null : 'contained',
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly ? null : <ListIcon/>,
  };
  return (
    iconOnly
    ? <Tooltip title='View Sessions'>
      <IconButton {...childProps}>
        <ListIcon/>
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
      Sessions
    </Button>
  );
};

PatientSessionsButton.defaultProps = {
  iconOnly: false,
};

PatientSessionsButton.propTypes = {
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default PatientSessionsButton;
